<template>
    <div>
        <v-row>
            <v-spacer></v-spacer>
            <v-col cols="11" sm="11" md="11" style="margin-left: 10px;">
                <v-select v-model="selectedChart" :items="charts" label="Select Chart" 
                item-text="name"
                item-value="value" multiple chips>
                </v-select>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-container style="overflow:auto" class="text-center">
            <v-card v-if="show.c1" class="d-inline-block ma-2" outlined>
                <v-card-title class="justify-center"><h4>จำนวนการนัดหมายรายวัน</h4></v-card-title>
                <v-divider></v-divider>
                <v-card-subtitle>
                <v-row>
                <v-col>
                    <DatePicker label='ตั้งแต่วันที่' :date='startdate_0' @change="(date) => {startdate_0=date;reload_0();}"></DatePicker>
                </v-col>
                <v-col>
                    <DatePicker label='ถึงวันที่' :date='enddate_0' @change="(date) => {enddate_0=date;reload_0();}"></DatePicker>
                </v-col>
                </v-row>
                </v-card-subtitle>
                <BarChart :chartData="barData"></BarChart>
            </v-card>
            <v-card v-if="show.c2" class="d-inline-block ma-2" outlined>
                <v-card-title class="justify-center"><h4>จำนวนการนัดหมายโดยเฉลี่ย</h4></v-card-title>
                <v-divider></v-divider>
                <v-card-subtitle>
                    <v-row>
                    <v-col>
                        <v-select
                            v-model='month_select'
                            :items="months"
                            item-value='val'
                            item-text='month'
                            label="ข้อมูลของเดือน"
                            @change='reload_1()'
                        >
                        </v-select>
                    </v-col>
                    </v-row>
                </v-card-subtitle>
                <PieChart :chartData="pieData"></PieChart>
            </v-card>
            <v-card v-if="show.c3" class="d-inline-block ma-2" outlined>
                <v-card-title class="justify-center"><h4>พฤติกรรมสมาชิกระบบรายสัปดาห์</h4></v-card-title>
                <v-divider></v-divider>
                <LineChart :chartData="lineData"></LineChart>
            </v-card>
            <v-card v-if="show.c4" class="d-inline-block ma-2" outlined>
                <v-card-title class="justify-center"><h4>สัดส่วนพฤติกรรมสมาชิกระบบ</h4></v-card-title>
                <v-divider></v-divider>
                <PieChart :chartData="pieData2"></PieChart>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

import LineChart from './Chart/LineChart'
import BarChart from './Chart/BarChart'
import PieChart from './Chart/PieChart'

import DatePicker from '@/components/Common/DatePicker.vue'

export default {
    props: ["station_code"],
    components: {
        LineChart,
        BarChart,
        PieChart,
        DatePicker
    },
    watch: {
        selectedChart: function(newVal) {
            this.show = Object.assign({}, this.defaultItem);
            newVal.forEach(element => {
                switch(element) {
                    case 0: this.show.c1 = true; break;
                    case 1: this.show.c2 = true; break;
                    case 2: this.show.c3 = true; break;
                    case 3: this.show.c4 = true; break;
                }
            });
        }
    },
    data: () => ({
        startdate_0 : null,
        enddate_0 : null,
        lineData: null,
        barData: null,
        pieData: null,
        pieData2: null,
        show: {c1: true, c2: true, c3: false, c4: false},
        selectedChart: [0, 1],
        charts: [
            {name: 'จำนวนการนัดหมายรายสัปดาห์', value: 0},
            {name: 'จำนวนการนัดหมายโดยเฉลี่ย', value: 1},
            //{name: 'พฤติกรรมสมาชิกระบบรายสัปดาห์', value: 2},
            //{name: 'สัดส่วนพฤติกรรมสมาชิกระบบ', value: 3}
            ],
        th_months: [
            'มกราคม',
            'กุมภาพันธ์',
            'มีนาคม',
            'เมษายน',
            'พฤษภาคม',
            'มิถุนายน',
            'กรกฎาคม',
            'สิงหาคม',
            'กันยายน',
            'ตุลาคม',
            'พฤษจิกายน',
            'ธันวาคม'
        ],
        month_select : {},
        months : [

        ]
    }),
    methods: {
        reload_0(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.dashboard.get_activatestatold,{
                station_code : this.station_code
                ,start_date : this.startdate_0
                ,end_date : this.enddate_0
            },{ headers: Staff.getTokenHeader()}
            ).then(response => {
                var d = new Date(this.startdate_0)
                d.setHours(d.getHours()+7)

                var d2 = new Date(this.enddate_0)
                d.setHours(d.getHours()+7) 

                var range = parseInt((d2.getTime()-d.getTime())/(24*3600*1000)) + 2

                var data = {}
                for(var i = 1;i<=range;i++){
                    data['day' + i] = {status1:0,status2:0,status3:0,status4:0}
                }

                var labels = []
                for(i = 1;i<=range;i++){
                    var day = d.toISOString().substring(0,10)
                    labels.push(day)
                    response.data.filter(d=>{
                        var date = new Date(d.reservation_date)
                        date.setHours(date.getHours()+7)
                        return date.toISOString().substring(0,10) == day
                    }).forEach(d=>{
                        data['day' + i]['status' + d.status] = d.cnt
                    })
                    d.setDate(d.getDate()+1)
                }

                this.barData = {
                    labels: labels,
                    datasets: [
                        {
                            label: 'จำนวนคนตรงต่อเวลา',
                            backgroundColor: '#4351cb',
                            data: []
                        },
                        {
                            label: 'จำนวนคนมาก่อนเวลา',
                            backgroundColor: '#e5cd6f',
                            data: []
                        },
                        {
                            label: 'จำนวนคนมาหลังเวลา',
                            backgroundColor: '#d2f316',
                            data: []
                        },
                        {
                            label: 'จำนวนคนไม่มาตามนัด',
                            backgroundColor: '#f33558',
                            data: []
                        },
                    ]
                }

                for(i = 1;i<=range;i++){
                    this.barData.datasets[0].data.push(data['day' + i].status1)
                    this.barData.datasets[1].data.push(data['day' + i].status2)
                    this.barData.datasets[2].data.push(data['day' + i].status3)
                    this.barData.datasets[3].data.push(data['day' + i].status4)
                }

                this.$store.commit('finishLoading',que)
            })
            .catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        reload_1(){
            var que = this.$store.commit('addLoading')

            var pie_start_date = this.month_select.substring(0,4) + '-' + this.month_select.substring(4,6) + '-01'
            var d = new Date(pie_start_date)
            d.setHours(d.getHours()+7)
            d.setMonth(d.getMonth()+1)
            d.setDate(d.getDate()-1)
            var pie_end_date = d.toISOString().substring(0,10)

            axios
            .post(config.api.url.manage.dashboard.get_activatestatold,{
                station_code : this.station_code
                ,start_date : pie_start_date
                ,end_date : pie_end_date
            },{ headers: Staff.getTokenHeader()}
            ).then((response) => {

                this.pieData = {
                    labels: ['จำนวนคนตรงต่อเวลา', 'จำนวนคนมาก่อนเวลา', 'จำนวนคนมาหลังเวลา', 'จำนวนคนไม่มาตามนัด'],
                    datasets: [
                        {
                            label: 'จำนวนคนตรงต่อเวลา',
                            backgroundColor: ['#69da63', '#e5cd6f', '#d2f316', '#f33558'],
                            data: []
                        }
                    ]
                }
                for(var i=1;i<5;i++){
                    var cnt  = response.data.filter(d=>String(d.status) == String(i))
                    if(cnt.length == 0){
                        cnt = 0
                    }else{
                        cnt = cnt.reduce((a,b)=>{
                            return {cnt: parseInt(a.cnt) + parseInt(b.cnt)}
                        }).cnt
                    }
                    this.pieData.datasets[0].data.push(cnt)
                }

                this.$store.commit('finishLoading',que)
            })
            .catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        }
    },
    mounted : function () {

        var m = new Date()
        m.setHours(m.getHours()+7)
        m.setMonth(m.getMonth()-13)
        for(var i=0;i<12;i++){
            m.setMonth(m.getMonth()+1)
            this.months.push({
                val: ("" + m.getFullYear()) + (m.getMonth()+1 < 10 ? "0": "") + ("" + (m.getMonth()+1))
                ,month:this.th_months[m.getMonth()] + " " + m.getFullYear()
            })
        }
        
        this.month_select = ("" + m.getFullYear()) + (m.getMonth()+1 < 10 ? "0": "") + ("" + (m.getMonth()+1))

        var d = new Date()
        d.setHours(d.getHours()+7)
        d.setDate(d.getDate()-1)
        this.enddate_0 = d.toISOString().substring(0,10)
        d.setDate(d.getDate()-6)
        this.startdate_0 = d.toISOString().substring(0,10)

        this.reload_0()
        this.reload_1()
    }
}

</script>